<template>
  <div id="app">
    <!-- <div id="nav"> -->
    <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
    <!-- </div> -->
    <router-view />

    <notifications group="success" position="top center" />
    <notifications
      :width="'100%'"
      :duration="5000"
      group="error"
      position="top left"
    />
  </div>
</template>

<script>
import mixin from "./mixins/helperMixin.js";
import filters from "./mixins/filters.js";

export default {
  name: "App",
  components: {},
  // metaInfo: {
  //   title: "eGalleria",
  //   titleTemplate:
  //     "%s | View, experience and buy art in a virtual gallery. As an artist you can display your art for a fraction of the cost of offline art gallery, with more visitors",

  //   meta: [
  //     { property: "og:title", content: "eGalleria" },
  //     {
  //       property: "og:description",
  //       content:
  //         "eGalleria, View, experience and buy art in a virtual gallery. As an artist you can display your art for a fraction of the cost of offline art gallery, with more visitors",
  //     },
  //     { property: "og:site_name", content: "eGalleria" },
  //     {
  //       name: "og:image",
  //       content: "@/assets/images/favicon.ico",
  //     },
  //   ],
  // },
  created() {
    document.addEventListener("contextmenu", event => event.preventDefault());
    document.onkeypress = function (event) {  
    event = (event || window.event);  
    if (event.keyCode == 123) {  
    return false;  
    }  
    }  
    document.onmousedown = function (event) {  
    event = (event || window.event);  
    if (event.keyCode == 123) {  
    return false;  
    }  
    }  
    document.onkeydown = function (event) {  
    event = (event || window.event);  
    if (event.keyCode == 123) {  
    return false;  
    }  
    } 
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap");

#app {
  font-family: "Titillium Web", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.vue-notification,
.vue-notification-template {
  text-align: center !important;
}

.vue-notification {
  padding: 2px !important;
  margin: 0px !important;
}
</style>
